// extracted by mini-css-extract-plugin
export var card = "_69-0";
export var failedIcon = "_69-4";
export var failedIconBadge = "_69-3";
export var icon = "_69-1";
export var successIcon = "_69-2";